const replaceStarsWithBulletPoints = (str: string) => {
    // Replace stars with bullet points
    return str.replaceAll('*', '•');
};

export default replaceStarsWithBulletPoints;
